import { getUrl, uploadData } from 'aws-amplify/storage';
import { useContext, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { ErrorContext } from '../ErrorContext';

const localhostLicense = 'Ml3-zgZweDUDbEXIC5OY1Z7r9Wk_waK7daRYMRZcjqD3K1E_OCdvalt6RMUy50eTicGKpxh61rBj-pWvMP6ZfuUlt5848M54ITEC2121VAuK0_lcQI7BVu7KlB1AgdTtuqjLxtOEgl16PZjUgpHKCfGeLFtBK5tp7KJtaXVw_o4RMzOo5rrmH4JIR9MxzWXyVdmlw5HrVFktfMgSg6_pSK3w3Kmbk0gqObbMugqfBWwzkpuNSLLshKzeR8KcnQA0Pu_WtZslyNnLqrFFExkzBVUKBzQfINP6wNMobvOw-761kCFuY2q69UoumY6LOM5hVulRava5VMAu7b8sdR1qJUln0kJzsquKc1vmzTvGbZvP-Ox3l_rYptaqQ-Rx9gjKrcbIvIEQmHaIyJIyGlDhNzlmbQQDYsO76fpPfYPZyU7-Vgg28883FFSckuMe-bKtWuOU3mn139PCHxrDTDbYi7_KTqPIm54fEM-dhg_lTlbJxTxw3aj4KHnCQHK7OaocecFJXIisBkzz6ERB9R9KC0yJYBUSsV82XOHsHGBDirSCJDMkd4Ku-tvcBbyT3Gq1HKIrccnozy-5P4uiXTPMbu3EM7Lgjzk3dB-66gkU3VJ-Nlu3VJfLDYe8M1-_8E4c';
const prodLicenseKey = 'EW4v7qAWzD_sYz0uuCVCP0XeWdESySz0SgmVrIfpF0o5nnD6O_X0BTKWBYG5SfiUuG9rY_J5mVZfKE_GmN2PlDTIWs9GiTcg_1BT39v5TWx9YANT5zPNevwywWTqenbQ23W-pe7Ed8zcVqrSalH6cNaF82zF0A-N2c4mHkRK3rz2A_Mm8QuK9B7CdS9lXKUdYcYROinLX7TXxwCdrM4Re-nZw-YzerlXXd_a4mPb6rTTFp1Y4P6VxBjju3WaZ6U8KIvMbiW-T1-k7FRbfdOkn-BN9mCPTQYSwbuSOkeqKH2BRz9Pdmu8j67ewipqnvIgFbr6jG346bfZqLEK_Ki3nHZP-qwAjKFhzB6xDvNc9qv29wkGHeBdMNXueW6MWTzYp9fi2ggBwX5kCub3HnyvtFubV9p-M0dnpvk8PXGcyC-OzPfdRvYqxAK5HawW_lKi03toll3gTVzVp9oF-kp2xt0ncdrRYtaO-n8Kk5KZAr3IsZ54b9wKQWRy5JKgoOnVQ2r10HCj2IDdg08nLOM14h2DaJ6w9cXgrv6gC4oh_VrepEnQvor7x8fug_r8SspN3edH9nP6DHqK9HEQbdcedsvKUJlzfiCNxThWGYDDx_ZGA1ZXHLFBka4NWCk08Wwf';

const PDFPreview = ({ document }) => {
    const errorContext = useContext(ErrorContext);
    const containerRef = useRef();

    useEffect(() => {
        let PSPDFKit, instance;
        const container = containerRef.current;

        (async () => {
            if (document) {
                try {
                    PSPDFKit = await import('pspdfkit');
                    const uri = await getUrl({ path: `public/${document.pdfKey}` });

                    let toolbarItems = [
                        { type: "zoom-in" },
                        { type: "zoom-out" },
                        { type: "print" },
                        { type: 'export-pdf' },
                    ]

                    if (document.fillable || document.draft) {
                        toolbarItems.unshift({
                            type: 'custom',
                            id: 'save',
                            title: 'Save Changes',
                            onPress: async () => {
                                try {
                                    await instance.save();
                                    const pdf = await instance.exportPDF();
                                    await uploadData({
                                        path: `public/${document.pdfKey}`, data: pdf, options: {
                                            contentType: "application/pdf",
                                            useAccelerateEndpoint: true,
                                        }
                                    }).result;
                                    toast.success("Saved Document");
                                    console.log('saved');
                                } catch (ex) {
                                    errorContext.setError({ errorMessage: "Failed to save PDF", forSupport: ex.message })
                                }
                            }
                        })
                        toolbarItems.unshift({ type: "form-creator" })
                    }

                    PSPDFKit?.unload(container);
                    instance = await PSPDFKit.load({
                        licenseKey: process.env.NODE_ENV === 'development' ? localhostLicense : prodLicenseKey,
                        container,
                        document: uri.url.toString(),
                        baseUrl: `${window.location.protocol}//${window.location.host}/${process.env.PUBLIC_URL}`,
                        toolbarItems,
                        enableClipboardActions: true,
                        enableHistory: true,
                    })
                } catch (ex) {
                    errorContext.setError({ errorMessage: "Failed to load PDF preview", forSupport: ex.message })
                }
            }
        })();

        return () => PSPDFKit?.unload(container);
    }, [document]);

    return <div ref={containerRef} style={{ width: '100%', height: '100%' }} />;
}

export default PDFPreview;